import Component from '../abstracts/Component';
import Cookie from 'js-cookie';


export default class FullMediaComponent extends Component {

  get SELECTORS() {
    return {
      main: '.c-full-media'
    };
  }

  get CLASSES() {
    return {
      scroll: 'scroll'
    }
  }

  get CONF() {
    let date = new Date();
    date.setTime(date.getTime() + (30*60*1000));

    return {
      scrollTimeout: 2000,
      removeTimeout: 1000,
      cookieName: 'full-media-shown',
      cookieConf: {
        expires: date,
        path: '/'
      }
    }
  }

  static get EVENTS() {
    return {
      scrolled: 'fullMedia:scrolled'
    };
  }

  constructor() {
    super();
  }

  getCookie() {
    return Cookie.get(this.CONF.cookieName);
  }

  setCookie() {
    return new Promise((resolve, reject) => {
      try {
        console.info(this.CONF.cookieConf)
        Cookie.set(this.CONF.cookieName, 'true', this.CONF.cookieConf);
        resolve(true);
      } catch (e) {
        reject(e)
      }
    });
  }

  removeEl(el) {
    return new Promise((resolve, reject) => {
      try {
        setTimeout(() => {
          const parent = el.parentElement;
          parent.removeChild(el);
          resolve(true);
        }, this.CONF.removeTimeout);
      } catch (e) {
        reject(e)
      }
    });
  }

  animate() {
    return new Promise((resolve, reject) => {
      try {
        const fullMedia = document.querySelector(this.SELECTORS.main);
        setTimeout(() => {
          fullMedia.classList.add(this.CLASSES.scroll);
          resolve(fullMedia)
        }, this.CONF.scrollTimeout);
      } catch (e) {
        reject(e);
      }
    });
  }

  bindEvents() {
    this.$on('resize.fullmedia', () => {
      if (this.$matchMedia('sm', null)) {
        this.animate().then(el => {
          this.removeEl(el).then(res => {
            this.setCookie();
          });
        }).catch(err => {
          this.removeEl(document.querySelector(this.SELECTORS.main));
        });
      }
    });
  }

  render() {
    if (document.querySelector(this.SELECTORS.main) && this.$matchMedia('sm', null) && !this.getCookie())
      this.animate().then(el => {
        this.removeEl(el).then(res => {
          this.setCookie();
        });
      }).catch(err => {
        this.removeEl(document.querySelector(this.SELECTORS.main));
      });
  }
}
